<template>
    <div class="p-8 lg:p-20">

        <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
            <RouterLink :to="`/what-we-believe`" class="h-44 bg-slate-200 relative what-we-believe">
                <div class="uppercase text-white font-bold text-3xl text-center flex justify-center items-center h-full relative">what we believe</div>
            </RouterLink>

            <RouterLink :to="`/our-leadership`" class="h-44 bg-slate-200 relative our-leadership">
                <div class="uppercase text-white font-bold text-3xl text-center flex justify-center items-center h-full">our leadership</div>
            </RouterLink>
        </div>
    </div>
</template>

<script setup>
</script>

<style scoped>
.our-leadership {
    background: linear-gradient(rgb(0, 0, 0, 0.5), rgb(0, 0, 0, 0.5)), url('../../assets/images/our_leadership.jpg');
    background-position: center;
    background-size: cover;
}

.what-we-believe {
    background: linear-gradient(rgb(0, 0, 0, 0.5), rgb(0, 0, 0, 0.5)), url('../../assets/images/what_we_believe.jpg');
    background-position: center;
    background-size: cover;
}
</style>